module.exports = __webpack_public_path__ + "static/media/Ciirve.5bc02015.svg";